import { Pencil, Trash2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button, Message, Skeleton } from '@/components/ui';

/** The table once there are rows; a skeleton before; the service's words if it failed; a sentence when there is nothing. */
export function Rows({ query, count, empty, children }: { query: { isPending: boolean; error: Error | null }; count: number; empty: string; children: ReactNode }) {
  if (query.isPending) {
    return (
      <div role="status" aria-label="Loading" className="flex flex-col gap-2 p-2.5">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    );
  }
  if (query.error !== null) {
    return <Message tone="error">{query.error.message}</Message>;
  }
  return count === 0 ? <p className="px-2.5 py-6 text-center text-xs text-muted">{empty}</p> : children;
}

export function RowActions({ name, onEdit, onDelete, children }: { name: string; onEdit: () => void; onDelete: () => void; children?: ReactNode }) {
  return (
    <span className="flex items-center justify-end gap-0.5">
      {children}
      <Button variant="ghost" onClick={onEdit} aria-label={`Edit ${name}`} title="Edit">
        <Pencil className="size-3.5" />
      </Button>
      <Button variant="ghost" onClick={onDelete} aria-label={`Delete ${name}`} title="Delete" className="hover:text-negative">
        <Trash2 className="size-3.5" />
      </Button>
    </span>
  );
}
